// extracted by mini-css-extract-plugin
export default {"formContainer":"applyCompany_formContainer__H7O9b","submitButton":"applyCompany_submitButton__jKo4H","errorMessage":"applyCompany_errorMessage__oiU2F"};